<style lang="less">
    .themeSet_container {
        position: relative;
        color: var(--text-color-themeset-container);
        height: 100%;
        .themeSet_activeTheme {
            margin-bottom: 10px;
            overflow: hidden;
            display: flex;
            .themeSet_themeEffect {
                position: relative;
                width: 98px;
                height: 120px;
                border: 1px solid var(--border-color-box-6);
                border-radius: 6px;
                background-color: var(--bg-color-primary);
                box-sizing: border-box;
                > img {
                    display: block;
                    position: absolute;
                    border-radius: 6px;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    margin: auto;
                    width: 100%;
                }
            }
            .themeSet_activeBox {
                margin-left: 16px;
                > div {
                    overflow: hidden;
                    cursor: pointer;
                    width: 90px;
                    height: 24px;
                    box-sizing: border-box;
                    margin-bottom: 8px;
                    &:hover {
                        background-color: var(--bg-color-themeset-hover);
                    }
                    > div {
                        float: left;
                        width: 24px;
                        height: 24px;
                        .item-icon {
                            width: 100%;
                            height: 100%;
                            color: var(--svg-color-gray-42);
                            fill: var(--svg-color-gray-75);
                        }
                    }
                    > p {
                        width: 62px;
                        height: 24px;
                        float: left;
                        margin-left: 4px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        line-height: 22px;
                    }
                }
            }
            > div {
                float: left;
            }
        }
        .themeSet_changeType {
            margin-bottom: 16px;
            box-sizing: border-box;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            column-gap: 2px;
            .active_Type {
                background-color: var(--bg-color-themeset-active-type);
            }
            > div {
                width: 48px;
                height: 60px;
                box-sizing: border-box;
                float: left;
                cursor: pointer;
                border-radius: 6px;
                &:hover {
                    background-color: var(--bg-color-themeset-hover);
                }
                .item-icon {
                    display: block;
                    width: 24px;
                    height: 24px;
                    margin: 6px auto 8px;
                    color: var(--svg-color-gray-42);
                    fill: var(--svg-color-gray-75);
                }
                > p {
                    font-size: 12px;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .themeSet_typeBox {
            position: relative;
            height: 100%;
            // width: calc(100% - 5px);
            // overflow-y: scroll;
            &::-webkit-scrollbar {
                display: none;
            }
            .ivu-tabs-bar {
                border-bottom: none;
                .ivu-tabs-tab {
                    font-size: 12px;
                    padding: 0 0 6px;
                    color: var(--text-color-primary);
                    max-width: 108px;
                    &:first-child {
                        margin-right: 32px;
                    }
                    &.ivu-tabs-tab-active {
                        font-weight: 700;
                        color: var(--themeColor);
                    }
                    &:hover {
                        color: var(--themeColor);
                    }
                }
                .ivu-tabs-ink-bar {
                    background-color: var(--themeColor);
                }
            }

            .themeSet_addBtn {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 32px;
                margin: 0 0 16px;
                background: #ffffff;
                border: 1px solid rgba(0, 0, 0, 0.08);
                // box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.08);
                border-radius: 6px;
                cursor: pointer;
                .item-icon {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
                span {
                    line-height: 16px;
                    color: #222;
                    font-size: 12px;
                }
            }

            .style-select {
                // width: 70px;
                width: unset;

                .ivu-select-selection {
                    border: none;
                    box-shadow: none;
                    background: transparent;
                    .ivu-select-selected-value {
                        color: var(--text-color-primary);
                        padding-left: unset;
                    }
                    .ivu-select-arrow {
                        color: var(--text-color-primary);
                    }
                }
            }

            .recommend-styles {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-bottom: 16px;
                .style-item {
                    min-width: 66px;
                    height: 24px;
                    padding: 0 4px;
                    line-height: 24px;
                    border-radius: 4px;
                    background: var(--bg-color-left-panel-itext-hover);
                    color: var(--text-color-primary);
                    font-size: 12px;
                    text-align: center;
                    cursor: pointer;
                    padding: 0 4px;
                    &:hover {
                        background: var(--theme-color-8);
                    }
                    &.active {
                        background: var(--theme-color-8);
                        color: var(--themeColor);
                    }
                }
            }

            .theme-list-wrapper {
                height: calc(100% - 136px);
                &.is-sdk {
                    height: calc(100% - 106px);
                }
                overflow: scroll;
                width: calc(100% + 21px);
                padding-right: 15px;
            }

            .theme-list {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                gap: 8px;
            }
            .mine-theme-list-wrapper {
                height: calc(100% - 60px);
                .theme-list {
                    margin-bottom: 8px;
                }
            }

            .themeSet_typeBox_theme {
                padding-bottom: 16px;
                &.is-sdk {
                    padding-bottom: 0;
                }
                height: 100%;

                .themeSet_typeBox_theme_box {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 110px;
                    height: 88px;
                    border-radius: 8px;
                    border: 1px solid var(--border-color-box-8);
                    &:hover {
                        border-color: var(--themeColor);
                    }
                    &.active_theme {
                        border: 2px solid var(--themeColor);
                    }
                    .themeSet_changeTheme {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        background-color: var(--bg-color-primary);
                        width: 100%;
                        height: 100%;
                        border-radius: 6px;
                        box-sizing: border-box;
                        cursor: pointer;
                        overflow: hidden;
                        .theme-vip-point {
                            position: absolute;
                            width: 20px;
                            height: 20px;
                            top: 4px;
                            right: 4px;
                            display: none;
                        }
                        > img {
                            display: block;
                            width: 100%;
                            -webkit-user-drag: none;
                            height: 100%;
                        }
                        .themeSet_menu {
                            display: none;
                            position: absolute;
                            right: 5px;
                            top: 5px;
                            width: 16px;
                            height: 16px;
                            .item-icon {
                                width: 100%;
                                height: 100%;
                                color: var(--svg-color-gray-42);
                            }
                            .themeSet_menu_list {
                                position: absolute;
                                width: 65px;
                                padding: 7px 0;
                                box-sizing: border-box;
                                border-radius: 5px;
                                background-color: #fafafa;
                                box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
                                right: 0;
                                top: 8px;
                                display: none;
                                > div {
                                    margin: 3px 0;
                                    padding: 0 7px;
                                    background-color: #fafafa;
                                    &:hover {
                                        background-color: #d9d9d9;
                                    }
                                }
                            }
                            &:hover .themeSet_menu_list {
                                display: block;
                            }
                        }
                        &:hover .themeSet_menu {
                            display: block;
                        }
                        &:hover .theme-vip-point {
                            display: block;
                        }
                    }
                }
                .no-custom-theme {
                    text-align: center;
                    margin-top: 80px;
                    width: 100%;
                    img {
                        width: 106px;
                    }
                    > div {
                        font-size: 12px;
                        color: var(--text-color-tertiary);
                        // margin-top: 8px;
                    }
                }
                .dash-line {
                    width: 100%;
                    height: 1px;
                    border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
                    margin: 24px 0;
                }
                .how-tip {
                    width: 100%;
                    background: rgba(242, 244, 249, 0.6);
                    border-radius: 8px;
                    font-size: 12px;
                    color: #222;
                    padding: 12px;
                    .how-title {
                        text-align: center;
                        font-weight: 700;
                        margin-bottom: 8px;
                    }
                }
                .edit-bar {
                    position: absolute;
                    z-index: 2;
                    bottom: -14px;
                    left: -15px;
                    height: 56px;
                    border-top: 1px solid var(--bg-color-logo-line);
                    padding: 12px 16px 12px;
                    display: flex;
                    align-items: center;
                    // background: var(--color-white);
                    width: calc(100% + 30px);
                    .edit-btn {
                        width: 100%;
                        height: 32px;
                        line-height: 32px;
                        background: var(--themeColor);
                        border-radius: 6px;
                        color: #fff;
                        font-size: 12px;
                        text-align: center;
                        cursor: pointer;
                        &:hover {
                            background: var(--themeHover);
                        }
                    }
                }
            }
            .themeSet_typeBox_color {
                padding-bottom: 16px;
                .style-select {
                    // width: 60px;
                    max-width: min-content;
                    margin-bottom: 10px;
                    .ivu-select-dropdown {
                        max-height: 250px;
                    }
                }
                .themeSet_addColor {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 200px;
                    height: 28px;
                    margin: 0 auto 16px auto;
                    background: var(--bg-color-primary);
                    border: 1px solid var(--border-color-themeset-add-xx);
                    box-shadow: var(--box-shadow-color-small);
                    border-radius: 6px;
                    cursor: pointer;
                    .item-icon {
                        width: 16px;
                        height: 16px;
                        color: var(--svg-color-gray-42);
                    }
                }
                .themeSet_changeColor {
                    height: 88px;
                    border-radius: 6px;
                    cursor: pointer;
                    position: relative;
                    margin-bottom: 8px;
                    border: 1px solid var(--border-color-box-8);
                    overflow: hidden;
                    .themeSet_colorBox {
                        width: 100%;
                        height: calc(100% - 32px);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 4px;
                    }
                    .themeSet_colorBlock {
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                    }
                    .themecolor-vip-point {
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        top: 2px;
                        right: 2px;
                        display: none;
                    }
                    &:hover {
                        border-color: var(--themeHover);
                        .themeSet_lockColor,
                        .themeSet_deleteColor,
                        .themecolor-vip-point {
                            display: block;
                        }
                    }
                    p {
                        width: calc(100% - 148px);
                        margin-left: 3px;
                        height: 16px;
                        line-height: 16px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .themeSet_lockColor,
                    .themeSet_deleteColor {
                        width: 14px;
                        height: 14px;
                        display: none;
                        > svg {
                            width: 100%;
                            height: 100%;
                        }
                        > .active_button {
                            display: none;
                        }
                        &:hover {
                            > * {
                                display: none;
                            }
                            > .active_button {
                                display: block;
                            }
                        }
                    }
                    .themeSet_lockColor.locked {
                        display: block;
                    }
                    &.active_theme {
                        border: 2px solid var(--themeColor);
                        .themeSet_deleteColor {
                            display: block;
                        }
                    }
                }
            }
            .themeSet_typeBox_line {
                padding-bottom: 16px;
                .themeSet_typeBox_theme_list {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .themeSet_changeLine_box {
                        width: 107.5px;
                        height: 107.5px;
                        // padding: 4px;
                        border-radius: 6px;
                        margin-bottom: 8px;
                        border: 1px solid var(--border-color-box-8);
                        position: relative;
                        overflow: hidden;

                        &:hover {
                            border-color: var(--themeColor);
                        }
                        &.active_theme {
                            border: 2px solid var(--themeColor);
                        }
                        .themeSet_changeLine {
                            position: relative;
                            width: 100%;
                            height: calc(100% - 32px);
                            box-sizing: border-box;
                            border-top-left-radius: 6px;
                            border-top-right-radius: 6px;
                            background: var(--bg-color-primary);
                            cursor: pointer;
                            .item-icon {
                                position: absolute;
                                width: 40px;
                                height: 30px;
                                display: block;
                                top: 0;
                                bottom: 0;
                                left: 0;
                                right: 0;
                                margin: auto;
                            }
                            .themeSet_lineMenu {
                                position: absolute;
                                right: 0;
                                width: 22px;
                                padding: 0 2px;
                                height: 100%;
                                // opacity: 0;
                                .themeSet_lockLine,
                                .themeSet_deleteLine {
                                    width: 18px;
                                    height: 18px;
                                    pointer-events: none;
                                    padding: 2px;
                                    > svg {
                                        width: 14px;
                                        height: 14px;
                                    }
                                    > .active_button {
                                        display: none;
                                    }
                                    &:hover {
                                        background-color: #e0e0e0;
                                        > * {
                                            display: none;
                                        }
                                        > .active_button {
                                            display: block;
                                        }
                                    }
                                }
                            }
                        }
                        .theme-vip-point {
                            position: absolute;
                            width: 20px;
                            height: 20px;
                            top: 4px;
                            right: 4px;
                            display: none;
                        }
                        &:hover .theme-vip-point {
                            display: block;
                        }
                    }
                    &::after {
                        content: "";
                        width: 33.33%;
                    }
                }
            }
            .themeSet_typeBox_text {
                .themeSet_changeText {
                    cursor: pointer;
                    border-radius: 8px;
                    padding: 22px 0;
                    border: 1px solid var(--border-color-box-8);
                    text-align: center;
                    margin-bottom: 8px;
                    position: relative;

                    .font-type {
                        font-size: 16px;
                        font-weight: 700;
                        margin-bottom: 8px;
                    }
                    .example {
                        font-size: 12px;
                        color: var(--text-color-primary);
                    }

                    &:hover {
                        .themeSet_lockText,
                        .themeSet_deleteText {
                            display: block;
                        }
                        border: 1px solid var(--themeColor);
                    }
                    &.ban-item {
                        opacity: 0.2;
                        filter: grayscale(100%);
                        pointer-events: none;
                    }
                    .themeSet_textIcon {
                        width: 24px;
                        height: 24px;
                        margin-left: 6px;
                        .item-icon {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    p {
                        float: left;
                        width: calc(100% - 55px);
                        margin-left: 6px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .themeSet_lockText.locked {
                        display: block;
                    }
                    &.active_theme {
                        // background-color: rgba(0, 0, 0, 0.06);
                        border: 2px solid var(--themeColor);
                        // background-color: rgba(59, 85, 149, 0.07);
                        .themeSet_deleteText {
                            display: block;
                        }
                    }
                }
            }
            .themeSet-item {
                position: relative;
                .themeSet_itemName {
                    text-align: center;
                    line-height: 32px;
                    background: var(--bg-color-right-panel-themeset-item-name);
                    font-size: 12px;
                    width: 100%;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span {
                        max-width: 90%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    svg {
                        margin-left: 4px;
                    }
                }
                .btns {
                    position: absolute;
                    right: 4px;
                    top: 4px;
                    align-items: center;
                    display: none;
                    .btn {
                        cursor: pointer;
                        background: #f5f6f9;
                        width: 24px;
                        height: 24px;
                        border-radius: 4px;
                        &:last-child {
                            margin-left: 4px;
                        }
                        svg {
                            width: 24px;
                            height: 24px;
                        }
                        &:hover {
                            // opacity: 0.6;
                            svg {
                                color: var(--themeColor);
                            }
                        }
                    }
                }
                &:hover {
                    .btns {
                        display: flex;
                    }
                }
            }
        }
    }
    /deep/.MsgBox-container .MsgBox-line {
        align-items: left !important;
    }
    /deep/ .ivu-tabs {
        .ivu-tabs-nav {
            .ivu-tabs-tab-active {
                color: var(--themeColor) !important;
            }
            .ivu-tabs-ink-bar {
                background: var(--themeColor) !important;
            }
        }
    }
</style>

<template>
    <setbox :setTitle="$t('ThemeSet.title')">
        <div class="themeSet_container">
            <!-- <div class="themeSet_activeTheme">
                <div class="themeSet_themeEffect">
                    <img :src="themeImg" draggable="false" />
                </div>
                <div class="themeSet_activeBox">
                    <div
                        class=""
                        @click="clickType(1)"
                        v-tippy="{ content: colorTheme ? colorTheme.localName(lang) : defaultColor, placement: 'bottom' }"
                    >
                        <div><iconSymbol name="theme-activeColor" class="item-icon"></iconSymbol></div>
                        <p v-text="colorTheme ? colorTheme.localName(lang) : defaultColor"></p>
                    </div>
                    <div
                        class=""
                        @click="clickType(3)"
                        v-tippy="{ content: textTheme ? textTheme.localName(lang) : defaultText, placement: 'bottom' }"
                    >
                        <div><iconSymbol name="theme-setText" class="item-icon"></iconSymbol></div>
                        <p v-text="textTheme ? textTheme.localName(lang) : defaultText"></p>
                    </div>
                    <div
                        class=""
                        @click="clickType(2)"
                        v-tippy="{ content: connectorTheme ? connectorTheme.localName(lang) : defaultLine, placement: 'bottom' }"
                    >
                        <div><iconSymbol name="theme-setLine" class="item-icon"></iconSymbol></div>
                        <p v-text="connectorTheme ? connectorTheme.localName(lang) : defaultLine"></p>
                    </div>
                    <div
                        v-if="!EDCONFIG.IS_SDK"
                        class=""
                        @click="showDialog(0)"
                        v-tippy="{ content: $t('ThemeSet.typeList.save'), placement: 'bottom' }"
                    >
                        <div><iconSymbol name="save-theme" class="item-icon"></iconSymbol></div>
                        <p>{{ $t("ThemeSet.typeList.save") }}</p>
                    </div>
                </div>
            </div>
            <div class="themeSet_changeType">
                <div
                    v-tippy="{ content: $t(item.text), placement: 'bottom' }"
                    :class="{ active_Type: item.id == activeType }"
                    v-for="item in typeList"
                    :key="item.id"
                    @click="clickType(item.id)"
                >
                    <div class="icon-box"><iconSymbol :name="item.name" class="item-icon"></iconSymbol></div>
                    <p>{{ $t(item.text) }}</p>
                </div>
            </div> -->
            <div class="themeSet_typeBox">
                <div class="themeSet_typeBox_theme" v-if="activeType == 0" :class="{ 'is-sdk': EDCONFIG.IS_SDK }">
                    <div class="top-select-bar" style="width: 100%">
                        <Tabs v-model="currentThemeTab">
                            <TabPane :label="$t('ThemeSet.recommendTheme')" name="recommend"></TabPane>
                            <TabPane :label="$t('ThemeSet.myTheme')" name="mine" v-if="!EDCONFIG.IS_SDK"></TabPane>
                        </Tabs>
                        <div class="recommend-styles" v-if="currentThemeTab === 'recommend'">
                            <div
                                class="style-item"
                                :class="{ active: themeStyle === item.id }"
                                v-for="item in themeStyleOption"
                                :key="item.id"
                                @click="themeStyle = item.id"
                            >
                                {{ $t(item.text) }}
                            </div>
                        </div>
                    </div>

                    <div class="theme-list-wrapper" :class="{ 'mine-theme-list-wrapper': currentThemeTab === 'mine', 'is-sdk': EDCONFIG.IS_SDK }">
                        <div v-if="currentThemeTab === 'recommend'" class="theme-list">
                            <template v-for="(item, i) in themes">
                                <div
                                    class="themeSet_typeBox_theme_box themeSet-item"
                                    :class="{ active_theme: theme && theme._id == item._id }"
                                    :key="item._id"
                                    @mouseleave="leave()"
                                    @mouseenter="enter()"
                                    v-if="
                                        !item.isCustom() &&
                                        (!filterTheme.themeIds || (filterTheme.themeIds && filterTheme.themeIds.indexOf(item._id) > -1))
                                    "
                                >
                                    <div
                                        class="themeSet_changeTheme"
                                        v-tippy="{ content: item.localName(lang), placement: 'bottom' }"
                                        @click="
                                            changeThemes(item._id);
                                            checkMindmap();
                                        "
                                        @mouseenter="hover(activeType, item._id)"
                                    >
                                        <img :src="getThemeIcon(item._id)" draggable="false" />
                                        <iconSymbol
                                            class="theme-vip-point"
                                            v-if="!vip && themeIds.includes(item._id)"
                                            :name="`vip-point${EDCONFIG.IS_SDK ? '-sdk' : ''}`"
                                        />
                                    </div>
                                </div>
                            </template>
                        </div>
                        <template v-else>
                            <div v-if="themes.filter((temp) => temp.isCustom()).length > 0" class="theme-list">
                                <template v-for="item in themes">
                                    <div
                                        class="themeSet_typeBox_theme_box themeSet-item"
                                        :class="{ active_theme: theme && theme._id == item._id }"
                                        :key="item._id"
                                        @mouseleave="leave()"
                                        @mouseenter="enter()"
                                        v-if="item.isCustom()"
                                    >
                                        <div
                                            class="themeSet_changeTheme"
                                            v-tippy="{ content: item.localName(lang), placement: 'bottom' }"
                                            @click="
                                                changeThemes(item._id);
                                                checkMindmap();
                                            "
                                            @mouseenter="hover(activeType, item._id)"
                                        >
                                            <img :src="getThemeIcon(item._id)" draggable="false" />
                                            <iconSymbol class="theme-vip-point" v-if="!vip && item._isVip" name="vip-point" />
                                            <div class="btns">
                                                <!-- <div class="themeSet_editText btn" @click.stop="showDialog(4, item._id, item.localName(lang))">
                                                    <iconSymbol name="themetext-edit"></iconSymbol>
                                                </div> -->
                                                <div class="themeSet_deleteText btn" @click.stop="openDelModal(item._id)">
                                                    <iconSymbol name="themetext-delete"></iconSymbol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <template v-else>
                                <div class="no-custom-theme" style="display: block">
                                    <img :src="require('@/app/assets/rightPanel/no_coustom_theme.png')" draggable="false" alt="" />
                                    <div>{{ $t("ThemeSet.noCustomTip") }}</div>
                                </div>
                                <div class="dash-line"></div>
                                <div class="how-tip">
                                    <div class="how-title">{{ $t("ThemeSet.noCustomThemeTipTitle") }}</div>
                                    <div class="how-content">{{ $t("ThemeSet.noCustomThemeTipContent") }}</div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <div class="edit-bar" v-if="!EDCONFIG.IS_SDK">
                        <div class="edit-btn" @click="handleEditTheme" v-if="showEditBtn">
                            {{ $t("ThemeSet.editCurrentTheme") }}
                        </div>
                    </div>
                </div>
                <div class="themeSet_typeBox_color" v-else-if="activeType == 1">
                    <Tabs v-model="currentColorTab">
                        <TabPane :label="$t('ThemeSet.recommendColor')" name="recommend"></TabPane>
                        <TabPane :label="$t('ThemeSet.myColor')" name="mine" v-if="!EDCONFIG.IS_SDK"></TabPane>
                    </Tabs>
                    <i-select size="small" v-model="themeColorStyle" class="style-select" v-if="currentColorTab === 'recommend'">
                        <i-option v-for="item in themeColorStyleOption" :value="item.id" :key="item.id">{{ $t(item.text) }}</i-option>
                    </i-select>
                    <template v-if="currentColorTab === 'recommend'">
                        <template v-for="item in colorThemes">
                            <div
                                class="themeSet_changeColor themeSet-item"
                                :key="item._id"
                                @click="changeThemeColors(item._id)"
                                :class="{ active_theme: colorTheme && colorTheme._id == item._id }"
                                @mouseenter="hover(activeType, item._id)"
                                @mouseleave="leave()"
                                v-if="
                                    !item.isCustom() &&
                                    (!filterThemeColor.colorIds || (filterThemeColor.colorIds && filterThemeColor.colorIds.indexOf(item._id) > -1))
                                "
                            >
                                <div class="themeSet_colorBox">
                                    <div
                                        class="themeSet_colorBlock"
                                        v-for="i in 8"
                                        :key="i"
                                        :style="{ backgroundColor: item._colors[i + 1][0] || '#000000' }"
                                    ></div>
                                </div>
                                <div class="themeSet_itemName" :title="item.localName(lang)">
                                    <span>{{ item.localName(lang) }}</span>
                                    <iconSymbol
                                        class="themecolor-vip-point"
                                        :name="`vip-point${EDCONFIG.IS_SDK ? '-sdk' : ''}`"
                                        v-if="!vip && themeColorIds.includes(item._id)"
                                    />
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="themeSet_addBtn" @click="showDialog(1)">
                            <iconSymbol name="save-themetext" class="item-icon"></iconSymbol>
                            <span>{{ $t("ThemeSet.newColor") }}</span>
                        </div>
                        <template v-for="item in colorThemes">
                            <div
                                class="themeSet_changeColor themeSet-item"
                                :key="item._id"
                                @click="changeThemeColors(item._id)"
                                :class="{ active_theme: colorTheme && colorTheme._id == item._id }"
                                @mouseenter="hover(activeType, item._id)"
                                @mouseleave="leave()"
                                :title="item.localName(lang)"
                                v-if="item.isCustom()"
                            >
                                <div class="themeSet_colorBox">
                                    <div
                                        class="themeSet_colorBlock"
                                        v-for="i in 8"
                                        :key="i"
                                        :style="{ backgroundColor: item._colors[i + 1][0] || '#000000' }"
                                    ></div>
                                </div>
                                <div class="themeSet_itemName" :title="item.localName(lang)">
                                    <span>{{ item.localName(lang) }}</span>
                                    <iconSymbol
                                        class="themecolor-vip-point"
                                        :name="`vip-point${EDCONFIG.IS_SDK ? '-sdk' : ''}`"
                                        v-if="!vip && themeColorIds.includes(item._fromId)"
                                    />
                                </div>
                                <div class="btns">
                                    <div class="themeSet_editText btn" @click.stop="showDialog(7, null, null, item)">
                                        <iconSymbol name="themetext-edit"></iconSymbol>
                                    </div>
                                    <div class="themeSet_deleteText btn" @click.stop="openDelModal(item._id)">
                                        <iconSymbol name="themetext-delete"></iconSymbol>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="themeSet_typeBox_line" v-else-if="activeType == 2">
                    <Tabs v-model="currentLineTab">
                        <TabPane :label="$t('ThemeSet.recommendStyle')" name="recommend"></TabPane>
                        <TabPane :label="$t('ThemeSet.myStyle')" name="mine" v-if="!EDCONFIG.IS_SDK"></TabPane>
                    </Tabs>
                    <div class="themeSet_typeBox_theme_list" v-if="currentLineTab === 'recommend'">
                        <template v-for="item in connectorThemes">
                            <div
                                class="themeSet_changeLine_box themeSet-item"
                                :class="{ active_theme: connectorTheme && connectorTheme._id == item._id }"
                                :key="item._id"
                                @mouseleave="leave()"
                                @mouseenter="enter()"
                                v-if="!item.isCustom()"
                            >
                                <div
                                    class="themeSet_changeLine"
                                    @click="
                                        changeThemeConnectors(item._id);
                                        checkMindmap();
                                    "
                                    @mouseenter="hover(activeType, item._id)"
                                >
                                    <img class="item-icon" :src="getThemeConnectorIcon(item._id)" draggable="false" />
                                </div>
                                <div class="themeSet_itemName">
                                    <span>{{ item.localName(lang) }}</span>
                                    <iconSymbol
                                        class="theme-vip-point"
                                        v-if="!vip && !themeLineIds.includes(item._id)"
                                        :name="`vip-point${EDCONFIG.IS_SDK ? '-sdk' : ''}`"
                                    />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="themeSet_typeBox_theme_list" v-else>
                        <div class="themeSet_addBtn" @click="showDialog(2)">
                            <iconSymbol name="save-themetext" class="item-icon"></iconSymbol>
                            <span>{{ $t("ThemeSet.newStyle") }}</span>
                        </div>
                        <template v-for="item in connectorThemes">
                            <div
                                class="themeSet_changeLine_box themeSet-item"
                                :class="{ active_theme: connectorTheme && connectorTheme._id == item._id }"
                                :key="item._id"
                                @mouseleave="leave()"
                                @mouseenter="enter()"
                                v-if="item.isCustom()"
                            >
                                <div
                                    class="themeSet_changeLine"
                                    :title="item.localName(lang)"
                                    @click="
                                        changeThemeConnectors(item._id);
                                        checkMindmap();
                                    "
                                    @mouseenter="hover(activeType, item._id)"
                                >
                                    <img class="item-icon" :src="getThemeConnectorIcon(item._id)" draggable="false" />
                                </div>
                                <div class="btns">
                                    <!-- <div class="themeSet_deleteLine btn" @click.stop="showDialog(6, null, null, item)">
                                        <iconSymbol name="themetext-edit"></iconSymbol>
                                    </div> -->
                                    <div class="themeSet_deleteText btn" @click.stop="openDelModal(item._id)">
                                        <iconSymbol name="themetext-delete"></iconSymbol>
                                    </div>
                                </div>
                                <div class="themeSet_itemName" :title="item.localName(lang)">
                                    <span>{{ item.localName(lang) }}</span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="themeSet_typeBox_text" v-else>
                    <Tabs v-model="currentTextTab">
                        <TabPane :label="$t('ThemeSet.recommendText')" name="recommend"></TabPane>
                        <TabPane :label="$t('ThemeSet.myText')" name="mine" v-if="!EDCONFIG.IS_SDK"></TabPane>
                    </Tabs>
                    <template v-if="currentTextTab === 'recommend'">
                        <template v-for="item in textThemes">
                            <div
                                class="themeSet_changeText"
                                :key="item._id"
                                @click="changeThemeTexts(item._id)"
                                :class="{ active_theme: textTheme && textTheme._id == item._id }"
                                @mouseenter="hover(activeType, item._id)"
                                @mouseleave="leave()"
                                :title="item.localName(lang)"
                                :style="{ fontFamily: item.localName(lang) }"
                                v-if="!item.isCustom()"
                            >
                                <div class="font-type">{{ item.localName(lang) }}</div>
                                <div class="example">ABCabc 123</div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="themeSet_addBtn" @click="showDialog(3)">
                            <iconSymbol name="save-themetext" class="item-icon"></iconSymbol>
                            <span>{{ $t("ThemeSet.newText") }}</span>
                        </div>
                        <template v-for="item in textThemes">
                            <div
                                class="themeSet_changeText themeSet-item"
                                :key="item._id"
                                @click="changeThemeTexts(item._id)"
                                :class="{ active_theme: textTheme && textTheme._id == item._id }"
                                @mouseenter="hover(activeType, item._id)"
                                @mouseleave="leave()"
                                :title="item.localName(lang)"
                                :style="{ fontFamily: item.localName(lang) }"
                                v-if="item.isCustom()"
                            >
                                <div class="font-type">{{ item.localName(lang) }}</div>
                                <div class="example">ABCabc 123</div>
                                <div class="btns">
                                    <!-- <div class="themeSet_editText btn" @click.stop="showDialog(5, null, null, item)">
                                        <iconSymbol name="themetext-edit"></iconSymbol>
                                    </div> -->
                                    <div class="themeSet_deleteText btn" @click.stop="openDelModal(item._id)">
                                        <iconSymbol name="themetext-delete"></iconSymbol>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </setbox>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import setbox from "./BaseSet.vue";
    import checkMindmap from "@/app/utils/checkMindmap";
    import { limitThemeId, limitThemeColorId } from "@/app/utils/constant";

    @Component({
        components: {
            setbox,
        },
    })
    export default class Theme extends Vue {
        @Inject()
        ["showMessage"];
        defaultColor: string = "Color";
        defaultText: string = "黑体";
        defaultLine: string = "General";
        typeList: Array<object> = [];
        isHover: boolean = false;
        timer: number;
        deleteIdx: number = -1;
        prevThemeId = 0;

        checkMindmap() {
            checkMindmap();
        }
        get themeIds() {
            return limitThemeId;
        }
        changeThemes(id: number, hover = false) {
            if (!hover && window.EDCONFIG.IS_SDK) {
                const iscustom = this.themes.find((i) => i._id === id).isCustom();
                if (this.themeIds.includes(id) && !this.vip && !iscustom) {
                    this.$checkAuth({ type: "themes", buyTrigger: "theme" });
                    return;
                }
            }
            this.activedThemeId = id;
            let view = window["_view"];
            if (view) {
                view.changeTheme(id, hover);
                if (!hover && !this.vip && this.themeIds.includes(id)) {
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "theme",
                    });
                }
            }
            if (!hover) {
                this.$nextTick(() => {
                    const changeTheme = this.themes.find((i) => i._id === id);
                    var styleOption = this.themeStyleOption.find((item) => {
                        return item.themeIds && item.themeIds.indexOf(changeTheme._id) > -1;
                    });
                    this.sensors.track("clickTheme", {
                        Catalogues: "rightMenu Bar",
                        theme_type: this.currentThemeTab === "recommend" ? "recommendTheme" : "myTheme",
                        theme_style: this.currentThemeTab === "recommend" ? (styleOption ? styleOption.key : "") : "",
                        theme_name: changeTheme._name,
                    });
                });
            }
            this.$bus.$emit("setEditEchartDataAdaptorThemeChange");
        }
        get themeColorIds() {
            return limitThemeColorId;
        }
        changeThemeColors(id: number, hover = false) {
            if (!hover && window.EDCONFIG.IS_SDK) {
                const iscustom = this.colorThemes.find((i) => i._id === id).isCustom();
                if (this.themeColorIds.includes(id) && !this.vip && !iscustom) {
                    this.$checkAuth({ type: "themesColor", buyTrigger: "themeColor" });
                    return;
                }
            }
            let view = window["_view"];
            if (view) {
                view.changeThemeColor(id, hover);
                if (!hover && !this.vip && this.themeColorIds.includes(id)) {
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "themeColor",
                    });
                }
            }
        }
        get themeLineIds() {
            return [100, 101];
        }
        changeThemeConnectors(id: number, hover = false) {
            if (!hover && window.EDCONFIG.IS_SDK) {
                if (!this.themeLineIds.includes(id) && !this.vip) {
                    this.$checkAuth({ type: "themes", buyTrigger: "theme" });
                    return;
                }
            }
            let view = window["_view"];
            if (view) {
                let themeList = this.connectorThemes.filter((item) => !item._custom);
                let vipId = themeList.map((item) => item._id);
                vipId = vipId.slice(2, themeList.length);
                view.changeThemeConnector(id, hover);
                if (!hover && !this.vip && vipId.includes(id)) {
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "connector",
                    });
                }
            }
        }
        changeThemeTexts(id: number, hover = false) {
            let view = window["_view"];
            if (view) {
                view.changeThemeText(id, hover);
            }
        }

        deleteThemes(type: number, idx: number) {
            let view = window["_view"];
            if (!view) return;
            if (type == 0) {
                //delete theme
                this.$track("rightPanel", "theme", "delete theme");
                view.deleteThemeJustTheme(idx);

                const { _clrThemeID, _cntThemeID, _textThemeID, _effThemeID } = this.theme;
                const customColorIds = this.filterCustomIds(this.colorThemes);
                const customConnectorIds = this.filterCustomIds(this.connectorThemes);
                const customTextIds = this.filterCustomIds(this.textThemes);
                const customEffectIds = this.filterCustomIds(this.effectThemes);
                if (customColorIds.indexOf(_clrThemeID) > -1) {
                    view.deleteThemeColorJustTheme(_clrThemeID);
                }
                if (customConnectorIds.indexOf(_cntThemeID) > -1) {
                    view.deleteLineThemeJustTheme(_cntThemeID);
                }
                if (customTextIds.indexOf(_textThemeID) > -1) {
                    view.deleteThemeFontJustTheme(_textThemeID);
                }
                if (customEffectIds.indexOf(_effThemeID) > -1) {
                    view.deleteThemeEffectJustTheme(_effThemeID);
                    //todo
                }
            } else if (type == 1) {
                //delete theme color
                this.$track("rightPanel", "theme", "delete theme color");
                view.deleteThemeColor(idx);
            } else if (type == 2) {
                //delete theme line
                this.$track("rightPanel", "theme", "delete theme line");
                view.deleteLineTheme(idx);
            } else {
                //delete theme text
                this.$track("rightPanel", "theme", "delete theme text");
                view.deleteThemeFonts(idx);
            }
        }

        filterCustomIds(list) {
            const _list = [];
            list.forEach((item) => {
                if (item.isCustom()) {
                    _list.push(item._id);
                }
            });
            return _list;
        }

        lockThemes(idx: number) {
            let view = window["_view"];
            if (!view) return;
            let type = "";
            let key = "";
            if (this.activeType == 1) {
                //lock theme color
                this.$track("rightPanel", "theme", "lock theme color");
                type = "clr";
                key = "lockClrTheme";
            } else if (this.activeType == 2) {
                //lock theme line
                this.$track("rightPanel", "theme", "lock theme line");
                type = "cnt";
                key = "lockCntTheme";
            } else if (this.activeType == 3) {
                //lock theme text
                this.$track("rightPanel", "theme", "lock theme text");
                type = "text";
                key = "lockTextTheme";
            }
            if (type) {
                let index = view.lockTheme(type, idx);
                let data = {};
                data[key] = index;
                this.$store.dispatch("setUserPrefer", data);
            }
        }

        openDelModal(idx: number) {
            let candel = true;
            if (this.activeType == 1 && this.lockClrTheme == idx) candel = false;
            else if (this.activeType == 2 && this.lockCntTheme == idx) candel = false;
            else if (this.activeType == 3 && this.lockTextTheme == idx) candel = false;
            let msg = this.$t("ThemeSet.warning");
            if (this.activeType == 1) {
                msg = this.$t("ThemeSet.warningColor");
            } else if (this.activeType == 2) {
                msg = this.$t("ThemeSet.warningLine");
            } else if (this.activeType == 3) {
                msg = this.$t("ThemeSet.warningText");
            }
            if (candel) {
                this.showMessage({
                    sponsor: "deleteTheme",
                    type: 0,
                    title: this.$t("ThemeSet.warningTitle"),
                    content: msg,
                });
                this.deleteIdx = idx;
            } else {
                this.showMessage({
                    sponsor: "deleteThemeFail",
                    type: 2,
                    content: this.$t("ThemeSet.deleteLock"),
                });
            }
        }
        get textDisabled() {
            return this.$store.state.ui.defaultFontType == 1;
        }
        getThemeIcon(id: number) {
            return this.$store.state.page.themesImageMap[id];
        }

        getThemeConnectorIcon(id: number) {
            return this.$store.state.page.themeConnectorsImageMap[id];
        }

        clickType(idx) {
            let arr = ["theme", "color", "connector", "font"];
            this.$track("rightPanel", "theme", "click" + arr[idx]);
            this.activeType = idx;
            switch (idx) {
                case 0:
                    checkMindmap();
                    break;
                case 2:
                    checkMindmap();
                    break;
            }
        }

        hover(type: number, id: number) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            switch (type) {
                case 0:
                    this.changeThemes(id, true);
                    break;
                case 1:
                    this.changeThemeColors(id, true);
                    break;
                case 2:
                    this.changeThemeConnectors(id, true);
                    break;
                case 3:
                    this.changeThemeTexts(id, true);
                    break;
            }
        }

        leave() {
            this.activedThemeId = this.prevThemeId;
            this.timer = setTimeout(() => {
                let view = window["_view"];
                if (view) {
                    view.themesLeave();
                    this.$nextTick(() => {
                        //处理 离开后hover的主题效果没取消问题
                        setTimeout(() => {
                            const ele = document.querySelector("#scene");
                            let currentScrollTop = ele.scrollTop;
                            ele.scrollTop = currentScrollTop + 1;
                            ele.scrollTop = ele.scrollTop - 1;
                        }, 10);
                    });
                }
                this.$bus.$emit("setEditEchartDataAdaptorThemeChange");
            }, 30);
        }
        enter() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        }

        showDialog(type: number, id?: number, name?: string, editItem?: any) {
            if (editItem) {
                if (type == 5) {
                    this.$store.commit("setStatus", {
                        type: "editTextOrigin",
                        data: editItem,
                    });
                }
                if (type == 6) {
                    this.$store.commit("setStatus", {
                        type: "editLineOrigin",
                        data: editItem,
                    });
                }
                if (type == 7) {
                    this.$store.commit("setStatus", {
                        type: "editColorOrigin",
                        data: editItem,
                    });
                }
            }
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "InsertTheme",
            });
            this.$store.commit("setStatus", {
                type: "insertThemetype",
                data: type,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            if (type == 0) {
                this.$track("rightPanel", "theme", "save theme");
            } else if (type == 1) {
                this.$track("rightPanel", "theme", "create color");
            } else if (type == 2) {
                this.$track("rightPanel", "theme", "create line");
            } else if (type == 3) {
                this.$track("rightPanel", "theme", "create text");
            }
            if (id) {
                this.$store.commit("setStatus", {
                    type: "renameThemeID",
                    data: id,
                });
            }
            if (name) {
                this.$store.commit("setStatus", {
                    type: "renameThemeName",
                    data: name,
                });
            }
        }

        initData() {
            this.typeList = [
                {
                    id: 0,
                    text: "ThemeSet.typeList.theme",
                    name: "theme-setTheme",
                    active: "theme-setTheme-active",
                },
                {
                    id: 1,
                    text: "ThemeSet.typeList.color",
                    name: "theme-setColor",
                    active: "theme-setColor-active",
                },
                {
                    id: 2,
                    text: "ThemeSet.typeList.line",
                    name: "theme-setLine",
                    active: "theme-setLine-active",
                },
                {
                    id: 3,
                    text: "ThemeSet.typeList.text",
                    name: "theme-setText",
                    active: "theme-setText-active",
                },
            ];
        }

        get themeImg() {
            return this.$store.state.page.activeThemeImage;
        }

        get activeType() {
            return this.$store.state.ui.showThemeType;
        }
        set activeType(v) {
            this.$store.state.ui.showThemeType = v;
        }

        get theme() {
            return this.$store.getters.theme;
        }

        get colorTheme() {
            return this.$store.getters.colorTheme;
        }

        get connectorTheme() {
            return this.$store.getters.connectorTheme;
        }

        get textTheme() {
            return this.$store.getters.textTheme;
        }

        get activedThemeId() {
            return this.$store.state.page.activedThemeId;
        }
        set activedThemeId(v) {
            this.$store.commit("setPageStat", {
                type: "activedThemeId",
                data: v,
            });
        }
        get lockClrTheme() {
            return this.$store.state.page.lockClrTheme;
        }
        get lockCntTheme() {
            return this.$store.state.page.lockCntTheme;
        }
        get lockTextTheme() {
            return this.$store.state.page.lockTextTheme;
        }

        currentTextTab = "recommend";
        currentLineTab = "recommend";
        currentColorTab = "recommend";
        currentThemeTab = "recommend";

        changeCurrentThemeTab(val) {
            this.currentThemeTab = val;
            this.scrollActiveTheme();
        }

        scrollActiveTheme() {
            this.$nextTick(() => {
                setTimeout(() => {
                    let activeEle = document.querySelector(`.themeSet_typeBox_theme_box.themeSet-item.active_theme`);
                    if (activeEle) {
                        activeEle.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                }, 500);
            });
        }

        get filterTheme() {
            return this.themeStyleOption.find((item: any) => item.id === this.themeStyle);
        }
        themeStyle = 1;
        get themeStyleOption() {
            return [
                {
                    id: 1,
                    text: this.$t("ThemeSet.all"),
                },
                {
                    id: 2,
                    text: this.$t("ThemeSet.business"),
                    themeIds: [36, 65, 75, 87, 88, 41, 48, 43, 89, 72, 73, 74],
                    key: "business",
                },
                {
                    id: 3,
                    text: this.$t("ThemeSet.technical"),
                    themeIds: [38, 37, 76, 77, 78, 60, 79, 47, 51],
                    key: "technical",
                },
                {
                    id: 4,
                    text: this.$t("ThemeSet.modern"),
                    themeIds: [90, 61, 62, 92, 63, 64, 50, 49, 66, 67, 68, 91, 69, 70, 71, 55, 93, 53, 54, 56, 57, 58],
                    key: "modern",
                },
                {
                    id: 5,
                    text: this.$t("ThemeSet.minimalist"),
                    themeIds: [80, 81, 82, 83, 42, 45, 84, 85, 40, 86, 52],
                    key: "minimalist",
                },
            ];
        }

        get filterThemeColor() {
            return this.themeColorStyleOption.find((item: any) => item.id === this.themeColorStyle);
        }
        themeColorStyle = 1;
        get themeColorStyleOption() {
            return [
                {
                    id: 1,
                    text: this.$t("ThemeSet.all"),
                    key: "all",
                },
                {
                    id: 2,
                    text: this.$t("ThemeSet.fresh"),
                    colorIds: [78, 32, 74, 82, 41, 47, 42, 129, 130, 131, 132],
                    key: "fresh",
                },
                {
                    id: 3,
                    text: this.$t("ThemeSet.vibrant"),
                    colorIds: [72, 77, 79, 80, 30, 39, 48, 112, 113, 114, 115, 116],
                    key: "vibrant",
                },
                {
                    id: 4,
                    text: this.$t("ThemeSet.muted"),
                    colorIds: [83, 70, 71, 73, 34, 76, 49, 43, 118, 119, 120, 120],
                    key: "muted",
                },
                {
                    id: 5,
                    text: this.$t("ThemeSet.soft"),
                    colorIds: [127, 126, 125, 124, 123, 46, 44, 45, 4, 122],
                    key: "soft",
                },
                {
                    id: 6,
                    text: this.$t("ThemeSet.vintage"),
                    colorIds: [37, 52, 31, 35, 50, 40, 133, 134, 135, 136],
                    key: "vintage",
                },
                {
                    id: 7,
                    text: this.$t("ThemeSet.warm"),
                    colorIds: [37, 102, 44, 43, 100, 101, 103, 104, 105, 106, 107],
                    key: "warm",
                },
                {
                    id: 8,
                    text: this.$t("ThemeSet.cold"),
                    colorIds: [39, 77, 48, 45, 46, 108, 109, 110, 111],
                    key: "cold",
                },
            ];
        }

        handleEditTheme() {
            this.$bus.$emit("itemChosen", "editTheme");
            this.sensors.track("editTheme", {
                Catalogues: "rightMenu Bar",
                theme_type: this.currentThemeTab === "recommend" ? "recommendTheme" : "myTheme",
            });
        }

        get showEditBtn() {
            return (
                this.currentThemeTab === "recommend" || (this.currentThemeTab === "mine" && this.themes.filter((temp) => temp.isCustom()).length > 0)
            );
        }

        initThemes() {
            let originData = this.themeIds;
            let arr = this.$store.getters.themes._themes.sort((a, b) => {
                const indexA = originData.indexOf(a._id);
                const indexB = originData.indexOf(b._id);
                if (indexA === -1 && indexB === -1) {
                    return 0;
                }

                if (indexA === -1) {
                    return -1;
                }
                if (indexB === -1) {
                    return 1;
                }
                return indexB - indexA;
            });

            this.themes = arr;
        }

        initColorThemes() {
            let arr = this.$store.getters.colorThemes._themeColors.sort((a, b) => {
                const indexA = this.themeColorIds.indexOf(a._id);
                const indexB = this.themeColorIds.indexOf(b._id);
                if (indexA === -1 && indexB === -1) {
                    return 0;
                }

                if (indexA === -1) {
                    return -1;
                }
                if (indexB === -1) {
                    return 1;
                }
                return indexB - indexA;
            });
            this.colorThemes = arr;
        }
        initConnectorThemes() {
            this.connectorThemes = this.$store.getters.connectorThemes._themeCnts;
        }
        initTextThemes() {
            this.textThemes = this.$store.getters.textThemes._themeText;
        }

        get effectThemes() {
            return this.$store.getters.effectThemes._themeEffs;
        }
        themes = [];
        colorThemes = [];
        connectorThemes = [];
        textThemes = [];
        initList() {
            this.initThemes();
            this.initColorThemes();
            this.initConnectorThemes();
            this.initTextThemes();
        }
        //生命周期
        mounted() {}

        created() {
            this.initList();
            this.initData();
            let ts: any = this;
            ts.$bus.$on("msgOperation", (data) => {
                if (data.sponsor == "deleteTheme" && data.data) {
                    ts.deleteThemes(ts.activeType, ts.deleteIdx);
                    ts.initList();
                }
            });
            ts.$bus.$on("refreshTheme", () => {
                this.initList();
            });
            this.$bus.$on("changeThemeAutoFormat", () => {
                this.scrollActiveTheme();
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("msgOperation");
            ts.$bus.$off("refreshTheme");
        }
        activated() {
            this.$bus.$emit("setRightViewTitle", "themeSet");
            this.$bus.$on("changeCurrentThemeTab", (val) => {
                this.changeCurrentThemeTab(val);
            });
            this.scrollActiveTheme();
        }
    }
</script>
<i18n>
{
  "zh": {
    "ThemeSet": {
      "title": "主题",
      "typeList": {
        "theme": "主题",
        "color": "颜色",
        "line": "连接线",
        "text": "文本",
        "save": "保存主题",
        "delete": "删除",
        "rename": "重命名"
      },
      "warning": "确认删除该主题？",
      "warningColor": "确认删除该颜色？",
      "warningLine": "确认删除该连接线？",
      "warningText": "确定要删除此主题文本样式吗？",
      "warningTitle": "删除",
      "deleteLock": "已锁定，删除失败",
      "recommendTheme": "推荐主题",
      "myTheme": "我的主题",
      "all": "全部",
      "business": "商务风",
      "technical": "工程风",
      "modern": "时尚风",
      "minimalist": "简约风",
      "noCustomTip": "当前还没有自己的主题哦~",
      "recommendColor": "推荐配色",
      "myColor": "我的配色",
      "fresh":"时尚",
      "vibrant": "清新",
      "muted": "鲜明", 
      "soft": "柔和",
      "vintage": "复古",
      "warm": "暖色",
      "cold": "冷色",
      "newColor": "新增配色",
      "recommendStyle": "推荐样式",
      "myStyle": "我的样式",
      "newStyle": "新增样式",
      "newText": "新增字体",
      "recommendText": "推荐文本",
      "myText": "我的文本",
      "noCustomThemeTipTitle": "如何自定义一个主题？",
      "noCustomThemeTipContent": "点击底部按钮自定义主题，设置“文本”、“连接线”和“配色”后，即可保存为自己的主题。",
      "editCurrentTheme": "编辑当前主题"
    }
  },
  "en": {
    "ThemeSet": {
      "title": "Theme",
      "typeList": {
        "theme": "Theme",
        "color": "Color",
        "line": "Connector",
        "text": "Text",
        "save": "Save Theme",
        "delete": "Delete",
        "rename": "Rename"
      },
      "warning": "Confirmed to delete this theme?",
      "warningTitle": "Delete",
      "deleteLock": "Locked, fail to delete.",
      "warningColor": "Confirmed to delete this color？",
      "warningLine": "Confirmed to delete this connecting line？",
      "warningText": "Confirmed to delete this text？",
      "recommendTheme": "Built-in Themes",
      "myTheme": "My Themes",
      "all": "All",
      "business": "Business",
      "technical": "Technical",
      "modern": "Modern",
      "minimalist": "Minimalist",
      "noCustomTip": "You haven't got a personal theme yet.",
      "recommendColor": "Built-in Colors",
      "myColor": "My Colors",
      "fresh":"Fresh",
      "vibrant": "Vibrant",
      "muted": "Muted", 
      "soft": "Modern",
      "vintage": "Vintage",
      "warm": "Warm",
      "cold": "Cold",
      "newColor": "New Colors",
      "recommendStyle": "Built-in Styles",
      "myStyle": "My Styles",
      "newStyle": "New Styles",
      "newText": "New Text",
      "recommendText": "Built-in Text",
      "myText": "My Text",
       "noCustomThemeTipTitle": "How to Customize a Theme?",
      "noCustomThemeTipContent": "Click the bottom button to edit the theme, set “Text,” “Lines,” and “Colors,” then save it as your theme.",
      "editCurrentTheme": "Edit"
    }
  },
  "fr": {
    "ThemeSet": {
      "title": "Thème",
      "typeList": {
        "theme": "Thème",
        "color": "Couleur",
        "line": "Ligne de connexion",
        "text": "Texte",
        "save": "Enregistrer le thème",
        "delete": "Effacer",
        "rename": "Renommer"
      },
      "warning": "Confirmé pour supprimer ce thème?",
      "warningColor": "Confirmé pour supprimer cette couleur?",
      "warningLine": "Confirmé pour supprimer cette ligne de connexion?",
      "warningText": "Confirmé pour supprimer ce texte?",
      "warningTitle": "Supprimer le sujet",
      "deleteLock": "Échec de la suppression, le sujet a été verrouillé",
      "recommendTheme": "Thèmes intégrés",
      "myTheme": "Mes thèmes",
      "all": "Tout",
      "business": "Entreprise",
      "technical": "Technique",
      "modern": "Moderne",
      "minimalist": "Minimaliste",
      "noCustomTip": "Vous n'avez pas encore défini de thème personnel.",
      "recommendColor": "Couleurs intégrées",
      "myColor": "Mes couleurs",
      "fresh":"Fraîche",
      "vibrant": "Dynamique",
      "muted": "Atténuée", 
      "soft": "Moderne",
      "vintage": "Vintage",
      "warm": "Chaleureuse",
      "cold": "Froide",
      "newColor": "Nouvelles couleurs",
      "recommendStyle": "Styles intégrés",
      "myStyle": "Mes styles",
      "newStyle": "Nouveaux styles",
      "newText": "Nouveau texte",
      "recommendText": "Texte intégrés",
      "myText": "Mes texte",
      "noCustomThemeTipTitle": "Comment personnaliser un thème ?",
      "noCustomThemeTipContent": "Cliquez sur le bouton du bas pour modifier le thème, définissez les paramètres « Texte », « Lignes » et « Couleurs », puis enregistrez-les en tant que thème.",
      "editCurrentTheme": "Modifier"
    }
  },
  "de": {
    "ThemeSet": {
      "title": "Thema",
      "typeList": {
        "theme": "Thema ",
        "color": "Farbe",
        "line": "Verbinder",
        "text": "Text",
        "save": "Thema speichern",
        "delete": "Löschen",
        "rename": "Umbenennen"
      },
      "warning": "Thema löschen bestätigen?",
      "warningColor": "Farbe löschen bestätigen?",
      "warningLine": "Verbindungslinie löschen bestätigen?",
      "warningText": "Text löschen bestätigen?",
      "warningTitle": "Löschen",
      "deleteLock": "Gesperrt, löschen fehlgeschlagen",
      "recommendTheme": "Integrierte Designs",
      "myTheme": "Meine Designs",
      "all": "Alle",
      "business": "Business",
      "technical": "Technisch",
      "modern": "Modern",
      "minimalist": "Minimalistisch",
      "noCustomTip": "Sie haben noch kein persönliches Design.",
      "recommendColor": "Integrierte Farben",
      "myColor": "Meine Farben",
      "fresh":"Frisch",
      "vibrant": "Lebendig",
      "muted": "Gedämpft", 
      "soft": "Modern",
      "vintage": "Vintage",
      "warm": "Warm",
      "cold": "Kalt",
      "newColor": "Neue Farben",
      "recommendStyle": "Integrierte Stile",
      "myStyle": "Meine Stile",
      "newStyle": "Neue Stile",
      "newText": "Neuer Text",
      "recommendText": "Neuer Text",
      "myText": "Meine Text",
      "noCustomThemeTipTitle": "Wie passe ich ein Design an?",
      "noCustomThemeTipContent": "Klicken Sie auf die untere Schaltfläche, um das Design zu bearbeiten, legen Sie „Text“, „Linien“ und „Farben“ fest und speichern Sie es als Design.",
      "editCurrentTheme": "Bearbeiten"
    }
  },
  "jp": {
    "ThemeSet": {
      "title": "テーマ",
      "typeList": {
        "theme": "テーマ",
        "color": "テーマ色",
        "line": "コネクター",
        "text": "テキスト",
        "save": "テーマを保存",
        "delete": "削除",
        "rename": "名前を変更"
      },
      "warning": "このトピックを削除しますか？",
      "warningColor": "この色を削除してもよろしいですか？",
      "warningLine": "この関連線を削除してもよろしいですか？",
      "warningText": "このテキストを削除してもよろしいですか？",
      "warningTitle": "トピックを削除",
      "deleteLock": "トピックはロックされているため、削除ができませんでした",
      "recommendTheme": "ビルトインのテーマ",
      "myTheme": "マイテーマ",
      "all": "すべて",
      "business": "ビジネス",
      "technical": "テクニカル",
      "modern": "モダン",
      "minimalist": "ミニマリスト",
      "noCustomTip": "個人用テーマがありません。",
      "recommendColor": "ビルトインの色",
      "myColor": "マイカラー",
      "fresh":"フレッシュ",
      "vibrant": "活気的",
      "muted": "落ち着いた", 
      "soft": "モダン",
      "vintage": "ヴィンテージ",
      "warm": "暖かい",
      "cold": "冷たい",
      "newColor": "新しい色",
      "recommendStyle": "ビルトインのスタイル",
      "myStyle": "マイスタイル",
      "newStyle": "新しいスタイル",
      "newText": "新しいテキスト",
      "recommendText": "ビルトインのしいテキスト",
      "myText": "私のテキストです",
      "noCustomThemeTipTitle": "テーマのカスタマイズ方法",
      "noCustomThemeTipContent": "下部のボタンをクリックしてテーマを編集し、「テキスト」、「線」、「色」を設定して、テーマとして保存します。",
      "editCurrentTheme": "編集"
    }
  },
  "es": {
    "ThemeSet": {
      "title": "Tema",
      "typeList": {
        "theme": "Tema",
        "color": "Color",
        "line": "Conector",
        "text": "Texto",
        "save": "Guardar el tema",
        "delete": "Borrar",
        "rename": "Renombrar"
      },
      "warning": "Confirmado para borrar este tema",
      "warningColor": "Confirmado para borrar este color",
      "warningLine": "Confirmado para borrar esta conexión line",
      "warningText": "¿Confirmado para borrar este text?",
      "warningTitle": "Borrar",
      "deleteLock": "Bloqueado, no se puede borrar",
      "recommendTheme": "Temas integrados",
      "myTheme": "Mis temas",
      "all": "Todo",
      "business": "Empresa",
      "technical": "Técnico",
      "modern": "Moderno",
      "minimalist": "Minimalista",
      "noCustomTip": "Aún no tienes un tema personal.",
      "recommendColor": "Colores integrados",
      "myColor": "Mis colores",
      "fresh":"Fresco",
      "vibrant": "Vibrante",
      "muted": "Tenue", 
      "soft": "Moderno",
      "vintage": "Vintage",
      "warm": "Cálido",
      "cold": "Frío",
      "newColor": "Nuevos colores",
      "recommendStyle": "Estilos integrados",
      "myStyle": "Mis estilos",
      "newStyle": "Nuevos estilos",
      "newText": "Nuevo texto",
      "recommendText": "Estilos texto",
      "myText": "Mis texto",
      "noCustomThemeTipTitle": "¿Cómo personalizo un tema?",
      "noCustomThemeTipContent": "Haz clic en el botón inferior para editar el tema, definir el «Texto», las «Líneas» y los «Colores» y guardarlo como tema.",
      "editCurrentTheme": "Editar"
    }
  },
  "pt": {
    "ThemeSet": {
      "title": "Tema",
      "typeList": {
        "theme": "Tema",
        "color": "Cor",
        "line": "Conector",
        "text": "Texto",
        "save": "Gravar Tema",
        "delete": "Eliminar",
        "rename": "Renomear"
      },
      "warning": "Confirmar para eliminar este tema?",
      "warningTitle": "Eliminar",
      "deleteLock": "Bloqueado, falha ao eliminar.",
      "warningColor": "Confirmar para eliminar esta cor？",
      "warningLine": "Confirmar para eliminar esta linha de conexão？",
      "warningText": "Confirmar para eliminar este texto？",
      "recommendTheme": "Temas integrados",
      "myTheme": "Meus temas",
      "all": "Todos",
      "business": "Empresarial",
      "technical": "Técnico",
      "modern": "Moderno",
      "minimalist": "Minimalista",
      "noCustomTip": "Você ainda não tem um tema pessoal.",
      "recommendColor": "Cores integradas",
      "myColor": "Minhas cores",
      "fresh":"Fresco",
      "vibrant": "Vibrante",
      "muted": "Silenciado", 
      "soft": "Moderno",
      "vintage": "Vintage",
      "warm": "Quente",
      "cold": "Frio",
      "newColor": "Novas cores",
      "recommendStyle": "Estilos integrados",
      "myStyle": "Meus estilos",
      "newStyle": "Novos estilos",
      "newText": "Novo texto",
      "recommendText": "Texto integrados",
      "myText": "Meus texto",
      "noCustomThemeTipTitle": "Como personalizar um tema?",
      "noCustomThemeTipContent": "Clique no botão inferior para editar o tema, defina “Texto”, “Linhas” e “Cores” e salve-o como tema.",
      "editCurrentTheme": "Editar"
    }
  },
  "it": {
    "ThemeSet": {
      "title": "Tema",
      "typeList": {
        "theme": "Tema",
        "color": "Colore",
        "line": "Connettore",
        "text": "Testo",
        "save": "Salva Tema",
        "delete": "Elimina",
        "rename": "Rinomina"
      },
      "warning": "Confermi di voler eliminare questo tema?",
      "warningTitle": "Elimina",
      "deleteLock": "L'elemento è bloccato. Impossibile eliminare.",
      "warningColor": "Confermi di voler eliminare questo colore?",
      "warningLine": "Confermi di voler eliminare questa linea di connessione?",
      "warningText": "Confermi di voler eliminare questo testo?",
      "recommendTheme": "Temi predefiniti",
      "myTheme": "I miei temi",
      "all": "tutto",
      "business": "Business",
      "technical": "Tecnico",
      "modern": "Moderno",
      "minimalist": "Minimalista",
      "noCustomTip": "Non hai ancora creato un tema personale.",
      "recommendColor": "Colori predefiniti",
      "myColor": "I miei colori",
      "fresh":"Fresco",
      "vibrant": "Vivace",
      "muted": "Tenue", 
      "soft": "Moderno",
      "vintage": "Vintage",
      "warm": "Caldo",
      "cold": "Freddo",
      "newColor": "Nuovi colori",
      "recommendStyle": "Stili predefiniti",
      "myStyle": "I miei stili",
      "newStyle": "Nuovi stili",
      "newText": "Nuovo testo",
      "recommendText": "Testo predefiniti",
      "myText": "I miei testo",
       "noCustomThemeTipTitle": "Come si personalizza un tema?",
      "noCustomThemeTipContent": "Fai clic sul pulsante in basso per modificare il tema, imposta “Testo”, “Linee” e “Colori“, quindi salva il tuo tema.",
      "editCurrentTheme": "Editar"
    }
  },
  "tw": {
    "ThemeSet": {
      "title": "主題",
      "typeList": {
        "theme": "主題",
        "color": "顏色",
        "line": "連接線",
        "text": "文本",
        "save": "儲存主題",
        "delete": "刪除",
        "rename": "重命名"
      },
      "warning": "確認刪除該主題？",
      "warningColor": "確認刪除該顏色？",
      "warningLine": "確認刪除該連接線？",
      "warningText": "確認刪除該文本？",
      "warningTitle": "刪除",
      "deleteLock": "已鎖定，删除失敗",
      "recommendTheme": "Built-in Themes",
      "myTheme": "My Themes",
      "all": "全部",
      "business": "Business",
      "technical": "Technical",
      "modern": "Modern",
      "minimalist": "Minimalist",
      "noCustomTip": "You haven't got a personal theme yet.",
      "recommendColor": "Built-in Colors",
      "myColor": "My Colors",
      "fresh":"Fresh",
      "vibrant": "Vibrant",
      "muted": "Muted", 
      "soft": "Modern",
      "vintage": "Vintage",
      "warm": "Warm",
      "cold": "Cold",
      "newColor": "New Colors",
      "recommendStyle": "Built-in Styles",
      "myStyle": "My Styles",
      "newStyle": "New Styles",
      "newText": "New Text",
      "recommendText": "Built-in Text",
      "myText": "My Text"
    }
  }
}
</i18n>
